import React from "react";
import { LinkContainer } from "react-router-bootstrap";
import { StyleSheet, Text, View } from "react-native";
export type Props = {};
export default function Introduction(props: Props) {
  return (
    <View style={styles.container}>
      <Text>
        ruggedbrain.com allows you to adopt new habits and skills with simple
        daily activities. You can use this habit, or you can build, use, and
        share your own habits.
      </Text>
      <LinkContainer style={styles.signuplink} to="/signup">
        <div>Sign Up</div>
      </LinkContainer>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    backgroundColor: "white",
    borderColor: "#BBBBBB",
    borderWidth: 2,
    borderRadius: 5,
    padding: 5,
    marginTop: 8,
    marginBottom: 0,
    marginLeft: 5,
    marginRight: 5,
  },
  title: {
    fontWeight: "bold",
  },
  signuplink: {
    width: "100%",
    fontWeight: "bold",
    textAlign: "center",
    padding: 5,
  },
});
